<app-setup-terms #componentTerms (termsAccepted)="TermsAccepted()"></app-setup-terms>
<app-setup-timezone #componentTimeZone (timeZoneSetEvent)="TimeZoneSet($event)"></app-setup-timezone>